.loader {
  height: var(--size);
  margin: auto;
  margin-bottom: var(--space-medium);
  margin-top: var(--space-medium);
  position: relative;
  width: var(--size);

  --color: var(--theme-blue);
  --size: 50px;
}

.loader div {
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border: 4px solid var(--color);
  border-color: var(--color) transparent transparent transparent;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  height: var(--size);
  position: absolute;
  width: var(--size);
}

.loader div:nth-child(1) {
  animation-delay: -0.45s;
}

.loader div:nth-child(2) {
  animation-delay: -0.3s;
}

.loader div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
